module.exports = __webpack_public_path__ + "img/slideshow-carnets-03-centrale.742ecb6b.png";